import { contactData } from '@/mocks/comicData';

export default function Contact() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[720px] mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
          {contactData.title}
        </h2>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 max-w-[520px] mx-auto">
          {contactData.content}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8">
          <div className="flex items-center gap-2 text-sm text-foreground-700">
            <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-100">
              <i className="ri-mail-line text-accent-600"></i>
            </div>
            <span>{contactData.email}</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-foreground-700">
            <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100">
              <i className="ri-chat-3-line text-primary-600"></i>
            </div>
            <span>{contactData.qq}</span>
          </div>
        </div>
      </div>
    </section>
  );
}